var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIconOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0599,
    cy: 24.0599,
    r: 24.0599,
    fill: "#143A72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5601 21.6621H28.5601H18.5601ZM18.5601 25.6621H22.5601H18.5601ZM23.5601 33.6621L19.5601 29.6621H16.5601C16.0296 29.6621 15.5209 29.4514 15.1458 29.0763C14.7708 28.7012 14.5601 28.1925 14.5601 27.6621V19.6621C14.5601 19.1317 14.7708 18.623 15.1458 18.2479C15.5209 17.8728 16.0296 17.6621 16.5601 17.6621H30.5601C31.0905 17.6621 31.5992 17.8728 31.9743 18.2479C32.3493 18.623 32.5601 19.1317 32.5601 19.6621V27.6621C32.5601 28.1925 32.3493 28.7012 31.9743 29.0763C31.5992 29.4514 31.0905 29.6621 30.5601 29.6621H27.5601L23.5601 33.6621Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconOrange);
export default __webpack_public_path__ + "static/media/chat_icon_orange.576333cac6d1b47ba4ce16e2cdff5b87.svg";
export { ForwardRef as ReactComponent };